import React from 'react';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="global-footer">
      <div className="footer-content">
        <div className="footer-links">
          <a 
            href="https://kickinon.com/policies/privacy-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Privacy Policy
          </a>
          <span className="footer-divider">|</span>
          <a 
            href="https://kickinon.com/pages/contact" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Contact
          </a>
        </div>
        
        <p className="footer-disclaimer">
          This product does not treat but helps relieve, it is not endorsed by Meta or Google, 
          Nor endorsed by Facebook, Instagram, YouTube or TikTok.
        </p>
      </div>
    </footer>
  );
};

export default Footer;